import clsx from 'clsx';
import React from 'react';
import EditIcon from '../../assets/icons/edit-icon.svg?react';
import Input from '../Input';
import Button from '../Button';
import { useButtonSizeSmall } from '../../utils/buttonSizes';
import { IncidentTypes } from '@EHSNavigator/backend';

interface EditCustomIncidentTypeModalProps {
  otherClasses?: string;
  formHandler: any;
  handleClose: () => void;
  currentIncidentType: IncidentTypes | null;
}

const EditCustomIncidentTypeModal: React.FC<
  EditCustomIncidentTypeModalProps
> = ({ otherClasses, formHandler, handleClose, currentIncidentType }) => {
  const editCustomIncidentTypeModalClasses = clsx(otherClasses);
  const lg = useButtonSizeSmall();
  return (
    <div
      className={editCustomIncidentTypeModalClasses}
      data-testid="edit-custom-incident-type-modal"
    >
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <EditIcon className="[&>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-byzantine">Edit Category</h4>
      </div>
      <form action="#" onSubmit={formHandler?.handleSubmit}>
        <div className="mb-6 flex flex-col">
          <p className="text-form-label -tracking-form-label font-inter-variable text-neutral-tones-text font-bold">
            Existing Name
          </p>
          <p className="text-neutral-tones-text font-inter-variable mt-2.5 text-base leading-5 font-normal capitalize">
            {currentIncidentType?.name}
          </p>
        </div>
        <div className="mt-2.5 grid grid-cols-1">
          <Input
            onBlur={formHandler?.handleBlur}
            label="New Category Name"
            errorMessage={
              formHandler?.touched.name && formHandler?.errors.name
                ? formHandler?.errors.name
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.name}
            type="text"
            placeholder="e.g. Near Miss"
            onChange={formHandler?.handleChange}
            name="name"
            otherClasses={{ container: 'w-full' }}
          />
        </div>

        <div className="mt-8 flex flex-col-reverse gap-15 md:grid md:grid-cols-2 md:gap-6 lg:mt-12">
          <Button
            variant="secondary"
            type="button"
            size={lg}
            onClick={() => handleClose()}
            otherClasses="text-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
          >
            Discard Changes
          </Button>
          <Button
            loading={formHandler?.isSubmitting}
            disable={
              formHandler?.values.name === currentIncidentType?.name ||
              formHandler?.isSubmitting
            }
            type="submit"
            size={lg}
          >
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditCustomIncidentTypeModal;
